import setFieldValue from "@bevco/Store/Handlers/InstantRegistrationForm/SetFieldValue";
import { CustomActions, CustomState } from "@bevco/Store/Reducers";
import {
    OwnProps,
    setInstantFormEffects,
    setRequestFormEffects,
} from "@bevco/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    instantRegEmail: state.customInstantRegistrationForm.fieldValues.instantRegEmail,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const instantRegEmailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const InstantRegEmail: React.FC<Props> = ({instantRegEmail, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Instant Email Address");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validateEmail = () => {
        let errorMessage: any = "";
        if (!instantRegEmail && isRequired) {
            errorMessage = siteMessage("Field_Required", label);
        } else if (instantRegEmail && !instantRegEmailRegexp.test(instantRegEmail)) {
            errorMessage = siteMessage("ContactUsForm_EmailIsInvalidErrorMessage");
        }

        setFieldErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    setInstantFormEffects(isRequired, instantRegEmail, "instantRegEmail", validateEmail);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "instantRegEmail", value: event.target.value });
    };

    const fieldBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        validateEmail();
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={instantRegEmail || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            onBlur={fieldBlurHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(InstantRegEmail);
